import { construct } from "@mrwa/rime-replacement/esriControls/unions";

export const FileType = {
  FileSystem: (file) => construct("FileSystem", [file]),
  Url: (url, name) => construct("Url", [url, name]),
};

export function getFileName(fileUnion) {
  return fileUnion.case({
    FileSystem: (file) => file.name,
    Url: (_, name) => name,
  });
}
